const AnjuAllReleases2019Static = () => {
    return (
      <>
        <div class="gallery_containerThree-static">  

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/anjuonline/knife-shopping" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000612828961-z6bi6e-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>Knife Shopping</strong>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/anjuonline/ringtone4myburnermp3" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000652553566-qym0d6-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>Ringt0ne4MyBurner.mp3</strong>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">DJ Set</p>
            <a href="https://www.youtube.com/watch?v=WP598fnjOMM" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-tF08flAkDpvmjgof-uvDVsg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Hellscape Radio Vol. 2</strong><br/>
                (Hosted by ANJU Online!)
              </p>
            </a>
          </div>          

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/anjuonline/flora-1" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000608076520-bpxk7e-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>Flora</strong>
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">Remix</p>
            <a href="https://soundcloud.com/anjuonline/i-can-make-a-call" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000605219989-6hjpuo-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>Pusha T - Drug Dealers Anonymous</strong><br/>
                (ANJU Online! Flip)
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">DJ Set</p>
            <a href="https://www.youtube.com/watch?v=63cbQdzd_oo" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000594396492-7c85fj-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Hellscape Radio Vol. 1</strong><br/>
                (Hosted by ANJU Online!)
              </p>
            </a>
          </div>          

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/anjuonline/distracted-active" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000479130057-gvq3oj-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>Distracted / Active!</strong>
              </p>
            </a>
          </div>

        </div>
      </>
    );
  };
  export default AnjuAllReleases2019Static;